import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function OfferStack() {
  const items = [{
    name: '📘 The Canine BioClock Protocol™ (60-Page PDF)',
    value: '$97'
  }, {
    name: '📋 The 30-Day Vitality Roadmap',
    value: '$47'
  }, {
    name: '🫐 The Superfood Dosage Cheat Sheet',
    value: '$27'
  }, {
    name: '💧 The Tap Water Detox Guide',
    value: '$19'
  }, {
    name: '🚫 The Dirty Dozen Ingredient Blacklist',
    value: '$17'
  }];
  return <section id="offer-stack" className="py-20 md:py-28 px-6 bg-surface" data-id="element-98">
      <div className="max-w-2xl mx-auto" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="bg-deep border-2 border-amber/40 rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-101">
            <div className="absolute inset-0 bg-amber/5 pointer-events-none" data-id="element-102"></div>

            <div className="bg-amber/10 p-6 text-center border-b border-amber/20 relative z-10" data-id="element-103">
              <h3 className="uppercase tracking-wide text-amber font-bold text-lg" data-id="element-104">
                COMPLETE PROTOCOL BUNDLE
              </h3>
            </div>

            <div className="p-8 md:p-10 relative z-10" data-id="element-105">
              <div className="space-y-0" data-id="element-106">
                {items.map((item, index) => <div key={index} className="flex justify-between items-center py-4 border-b border-white/5 last:border-0" data-id="element-107">
                    <span className="text-white font-medium pr-4" data-id="element-108">
                      {item.name}
                    </span>
                    <span className="text-muted line-through font-mono" data-id="element-109">
                      {item.value}
                    </span>
                  </div>)}
              </div>

              <div className="mt-8 pt-8 border-t border-white/10 text-center" data-id="element-110">
                <p className="text-muted text-lg mb-2" data-id="element-111">
                  Total Value: <span className="line-through" data-id="element-112">$207</span>
                </p>
                <div className="flex items-center justify-center gap-4 mb-2" data-id="element-113">
                  <span className="text-5xl font-bold text-amber" data-id="element-114">$27</span>
                </div>
                <p className="text-body mb-8" data-id="element-115">
                  One-time payment. Instant digital access.
                </p>

                <div data-id="element-116">
                  <CTAButton className="w-full" data-id="element-117">
                    YES! I WANT 5+ EXTRA YEARS WITH MY DOG
                  </CTAButton>
                  <p className="text-muted text-xs mt-3 tracking-wide" data-id="element-118">
                    Instant Access • One-time secure payment of $27
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}